import api from 'api';

export const loadPresets = (screen) =>
  api(`GET /api/profile/presets`)({
    key: `presets.${screen}`,
  });
export const editPreset = api(`PUT /api/profile/presets/:id`);
